import { addStyles } from 'ethcss'
import { grid, IStyles, item, mediaCSS, text } from 'theme'
import { defaultThemeStyles } from 'blocks.app/app/app.theme.jcss'

export const styles: IStyles = {
    ConfirmNotificationWithChoices: {
        boxShadow: `var(--var-module-app-component-app-style-shadow, ${defaultThemeStyles.shadow})`,
        ...item.abs,
        ...item.white,
        top: 0,
        left: 0,
        right: 0,
    },
    ConfirmNotificationWithChoices__button: {
        padding: 10,
        ...grid.rowCenter,
        ...item.pointer,
        textAlign: 'center',
        [mediaCSS.desktopS]: {
            fontSize: 12,
        },
    },
    ConfirmNotificationWithChoices__info: {
        padding: 10,
        ...grid.rowCenter,
        background: `var(--var-module-app-component-app-style-background, ${defaultThemeStyles.background})`,
        ...item.pointer,
        textAlign: 'center',
    },
    ConfirmNotification__body: {
        ...grid.row,
        ...grid.center,
        ...grid.mb_mini,
        textAlign: 'center',
        marginTop: 24,
    },
    ConfirmNotification__button_type_confirm: {
        ...grid.mr_mini,
        [mediaCSS.desktopS]: {
            fontSize: 12,
        },
    },
    checkboxLabel: {
        fontSize: 14,
        textAlign: 'left',

        [mediaCSS.desktopS]: {
            fontSize: 12,
        },
    },
    checkboxWrapper: {
        position: 'relative',
        lineHeight: 1.3,
    },
}

addStyles(styles)
